import { AUTH_HEADER } from '@/core/constants/http-headers'
import { safeParseFloat } from '@/core/lib/utils/parse-float'
import { IHttpClient } from '@/core/services/http'
import { ITokenService } from '@/core/services/tokens/token.service.interface'
import { ID } from '@/core/types/models/id.model'

export default function createCheckPromoCodeUseCase({
  httpClient,
  tokenService,
}: {
  httpClient: IHttpClient
  tokenService: ITokenService
}) {
  return async function ({
    tripId,
    promoCode,
  }: {
    tripId: ID
    promoCode: string
  }) {
    const { accountType, token } = await tokenService.getToken()
    const authHeader = token ? AUTH_HEADER(token) : {}
    const res = await httpClient.version('v1').addHeaders(authHeader).post<{
      data: {
        total_price: string
      }
    }>(`/website/${accountType}/tripPreview/${tripId}`, {
      promo_code: promoCode,
    })

    return {
      totalPrice: safeParseFloat(res.data.data.total_price),
    }
  }
}
